export const LocalStorageKeys = {
    Token: "Token",
    TokenAzure: "TokenAzure",
    TokenFireBase:"TokenFireBase"
}
export const RoleName = {
    SALLINGGROUP: "SALLINGGROUP",
    ADMINISTRATOR: "ADMINISTRATOR",
    VENDOR:"VENDOR"
}
export const FileTypeAccept = {
    FileAcceptTests:".pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel, image/*"
}